import {
    apiCallCenterGetConsultaDetalle,
    apiCallCenterGetHistorialClinico,
    apiEspecialidadGetResgistros,
    apiReportesDoctores,
    apiReportesDoctoresDescargar,
} from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";
import { fnHandleChangeDate, fnHandleChangeText } from "../settings/handleConfig";
import { getFormFiltro, getModelConsulta, getModelDoctor } from "../models/ReporteDoctorModel";

import { Button } from "@material-ui/core";
import { format } from "date-fns";
import { useLayout } from "./LayoutContext";
import { useRequest } from "./RequestContext";

export const ReporteDoctorContext = createContext();

export function ReporteDoctorProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { Get, GetFile } = useRequest();

    const [listaDoctores, setListaDoctores] = useState([]);
    const [listaEspecialidades, setListaEspecialidades] = useState([]);
    const [listaConsultas, setListaConsultas] = useState([]);
    const [doctorSeleccionado, setDoctorSeleccionado] = useState(getModelDoctor());
    const [consultaSeleccionada, setConsultaSeleccionada] = useState(getModelConsulta());
    const [formFiltro, setFormFiltro] = useState(getFormFiltro());
    const [entDoctores, setEntDoctores] = useState(null);
    const [entConsulta, setEntConsulta] = useState(null);
    const [historialClinico, setHistorialClinico] = useState(null);
    const [modalOpenDetalleDoctor, setModalOpenDetalleDoctor] = useState(false);
    const [modalOpenDetalleConsulta, setModalOpenDetalleConsulta] = useState(false);

    const handleOpenDetalleDoctor = (value) => {
        setModalOpenDetalleDoctor(value);
    };

    const handleOpenDetalleConsulta = (value) => {
        setModalOpenDetalleConsulta(value);
    };

    const handleChangeDoctorSeleccionado = (value) => {
        setDoctorSeleccionado(value);
    };

    const handleChangeConsultaSeleccionada = (value) => {
        setConsultaSeleccionada(value);
    };

    const handleChangeFormFiltroText = fnHandleChangeText(formFiltro, setFormFiltro);
    const handleChangeFormFiltroDate = fnHandleChangeDate(formFiltro, setFormFiltro);

    const handleClickDetalleDoctor = (doctor) => {
        setDoctorSeleccionado(doctor);
        if (doctor.lstConsultas) {
            setListaConsultas(
                doctor.lstConsultas.map((consulta) => ({
                    ...consulta,
                    name: consulta.entPaciente.name,
                    sFechaConsultaInicio:
                        consulta.sEstatusConsulta === "Creado/Programado" || consulta.sEstatusConsulta === "Cancelado"
                            ? consulta.sFechaProgramadaInicio
                            : consulta.sFechaConsultaInicio,
                    sFechaConsultaFin:
                        consulta.sEstatusConsulta === "Creado/Programado" || consulta.sEstatusConsulta === "Cancelado"
                            ? consulta.sFechaProgramadaFin
                            : consulta.sEstatusConsulta === "En consulta"
                            ? "Consultando"
                            : consulta.sFechaConsultaFin,
                    sDetalle: (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleClickDetalleConsulta(consulta)}
                        >
                            DETALLE
                        </Button>
                    ),
                }))
            );
        }
        setModalOpenDetalleDoctor(true);
    };

    const handleClickDetalleConsulta = async (consulta) => {
        setConsultaSeleccionada(consulta);
        setModalOpenDetalleConsulta(true);
        //await fnObtenerDetalleConsulta(consulta.iIdConsulta);
    };

    const handleClickFiltrarDoctores = () => {
        fnObtenerReporteDoctores(
            formFiltro.txtTipoDoctor.value,
            formFiltro.txtEspecialidad.value,
            formFiltro.txtEstatusConsulta.value,
            !formFiltro.txtFechaDe.value ? null : formFiltro.txtFechaDe.value.toISOString(),
            !formFiltro.txtFechaA.value ? null : formFiltro.txtFechaA.value.toISOString()
        );
    };

    const handleClickLimpiarFiltro = async () => {
        await fnObtenerReporteDoctores();
        setFormFiltro(getFormFiltro());
    };

    const handleClickDescargarReporte = () => {
        fnDescargarReporteDoctores(
            formFiltro.txtTipoDoctor.value,
            formFiltro.txtEspecialidad.value,
            formFiltro.txtEstatusConsulta.value,
            !formFiltro.txtFechaDe.value ? null : formFiltro.txtFechaDe.value.toISOString(),
            !formFiltro.txtFechaA.value ? null : formFiltro.txtFechaA.value.toISOString()
        );
    };

    const handleClickRefrescarDatos = async () => {
        await handleClickLimpiarFiltro();
        await fnObtenerEspecialidades();
    };

    const fnObtenerReporteDoctores = async (
        psIdTipoDoctor = "",
        psIdEspecialidad = "",
        psIdEstatusConsulta = "",
        pdtFechaConsultaInicio = null,
        pdtFechaConsultaFin = null
    ) => {
        const payload = {
            loader: "Obteniendo lista de doctores...",
            url:
                apiReportesDoctores +
                "?psIdTipoDoctor=" +
                psIdTipoDoctor +
                "&psIdEspecialidad=" +
                psIdEspecialidad +
                "&psIdEstatusConsulta=" +
                psIdEstatusConsulta +
                "&pdtFechaConsultaInicio=" +
                pdtFechaConsultaInicio +
                "&pdtFechaConsultaFin=" +
                pdtFechaConsultaFin,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setEntDoctores(response.Result);
            const { lstDoctores } = response.Result;
            if (lstDoctores) {
                setListaDoctores(
                    lstDoctores.map((doctor) => ({
                        ...doctor,
                        sDetalle: (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleClickDetalleDoctor(doctor)}
                            >
                                DETALLE
                            </Button>
                        ),
                    }))
                );
            }
        }
    };

    const fnDescargarReporteDoctores = async (
        psIdTipoDoctor = "",
        psIdEspecialidad = "",
        psIdEstatusConsulta = "",
        pdtFechaConsultaInicio = null,
        pdtFechaConsultaFin = null
    ) => {
        const payload = {
            loader: "Obteniendo lista de doctores...",
            url:
                apiReportesDoctoresDescargar +
                "?psIdTipoDoctor=" +
                psIdTipoDoctor +
                "&psIdEspecialidad=" +
                psIdEspecialidad +
                "&psIdEstatusConsulta=" +
                psIdEstatusConsulta +
                "&pdtFechaConsultaInicio=" +
                pdtFechaConsultaInicio +
                "&pdtFechaConsultaFin=" +
                pdtFechaConsultaFin,
            filename: `ReporteDoctores_${format(new Date(), "yyyy-MM-dd_HH-mm-ss")}.xlsx`,
            alert: false,
        };

        await GetFile(payload);
    };

    const fnObtenerEspecialidades = async () => {
        const payload = {
            loader: "Consultando especialidades...",
            url: apiEspecialidadGetResgistros,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaEspecialidades(response.Result);
        }
    };

    const fnObtenerDetalleConsulta = async (piIdConsulta = "") => {
        const payload = {
            loader: "Consultando detalles...",
            url: apiCallCenterGetConsultaDetalle + "?piIdConsulta=" + piIdConsulta,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const [consulta] = response.Result;
            if (consulta) {
                setEntConsulta(consulta);
                await fnObtenerDetalleHistorial(piIdConsulta);
            } else {
                handleOpenAlert("No se encontró el detalle de la consulta");
                setEntConsulta(getModelConsulta());
            }
        }
    };

    const fnObtenerDetalleHistorial = async (piIdConsulta = "") => {
        const payload = {
            loader: "Consultando historial clínico...",
            url: apiCallCenterGetHistorialClinico + "?piIdConsulta=" + piIdConsulta,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const [historia] = response.Result;
            if (historia) {
                setHistorialClinico(historia);
            } else {
                setHistorialClinico(null);
            }
        }
    };

    useEffect(() => {
        if (modalOpenDetalleConsulta) {
            if (consultaSeleccionada.iIdConsulta > 0) {
                fnObtenerDetalleConsulta(consultaSeleccionada.iIdConsulta);
            }
        }
        // eslint-disable-next-line
    }, [modalOpenDetalleConsulta]);

    return (
        <ReporteDoctorContext.Provider
            value={{
                listaEspecialidades,
                listaDoctores,
                listaConsultas,
                doctorSeleccionado,
                consultaSeleccionada,
                formFiltro,
                entDoctores,
                entConsulta,
                historialClinico,
                modalOpenDetalleDoctor,
                modalOpenDetalleConsulta,
                handleOpenDetalleDoctor,
                handleOpenDetalleConsulta,
                handleChangeDoctorSeleccionado,
                handleChangeConsultaSeleccionada,
                handleChangeFormFiltroText,
                handleChangeFormFiltroDate,
                handleClickDetalleDoctor,
                handleClickFiltrarDoctores,
                handleClickLimpiarFiltro,
                handleClickDescargarReporte,
                handleClickRefrescarDatos,
            }}
        >
            {props.children}
        </ReporteDoctorContext.Provider>
    );
}

export function useReporteDoctor() {
    return useContext(ReporteDoctorContext);
}
